/*=================================================
    summary: 老師 看 / 改 學生考卷 拼音 選擇題 Pinyin Identification 單元

    remarks: 000 Tim 2021/11/30 Create
             001 Tim 2021/12/23 加入 PaintedMe流程
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssAssignmentPinyinIdentification from './AssignmentPinyinIdentification.module.scss'
import {GlobalLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let marrDisplayQuestion = []
// #endregion Member Variables


const COMP_NAME = "AssignmentPinyinIdentification"

function AssignmentPinyinIdentification(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [playAudioIndex, setPlayAudioIndex] = useState(-1)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            window.AudioLibs.StopAudio()

            mblnInitialized = false

            setUpdateDataTime(0)
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 聲音播放
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function AudioPlayOnTapHandler(AudioFN, QuestionIndex)
    {
        console.log(COMP_NAME + ".AudioPlayOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        setPlayAudioIndex(QuestionIndex)
        
        let strAudioUrl = window.Globals.GetResourceUrl(props.BookCatID, props.LessonID, window.gResourceTypeEnum.Audio, AudioFN)
        window.AudioLibs.PlayAudio(strAudioUrl)
    } // end of AudioPlayOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler")

        setPlayAudioIndex(-1)
    } // end of PlayAudioEndHandler
    // #endregion Other EventHandler

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)

        marrDisplayQuestion = FormatPIQuestionData(props.LearningUnitData, props.TeacherAssignmentData)
        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe

    /*===========================================
    summary: 初始化 拼音 選擇題 答案資料
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function FormatPIQuestionData(LearningUnit, TeacherAssignment)
    {
        console.log(COMP_NAME + ".FormatPIQuestionData: ", LearningUnit, TeacherAssignment);

        let arrDisplaySentence = JSON.parse(JSON.stringify(LearningUnit.Sentence))
        let intSCount = LearningUnit.Sentence.length
        let arrAnswer = []
        let intNAIndex = 0

        let objAnswer = null
        let blnFinished = false

        if (
            (typeof(TeacherAssignment) !== 'undefined') &&
            (TeacherAssignment !== null) &&
            (typeof(TeacherAssignment.NewAssignList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList !== null) &&
            (TeacherAssignment.NewAssignList.length > 0) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex]) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex] !== null) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex].AnswerList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList !== null) &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList.length > 0)
            )
        {
            arrAnswer = TeacherAssignment.NewAssignList[intNAIndex].AnswerList
        }

        LearningUnit.Sentence.find(function(SentenceData, SentenceIndex)
        {
            objAnswer = arrAnswer.find(Answer => parseInt(Answer.SentenceSeqNo) === parseInt(SentenceData.SentenceSeqNo))

            if (
                (typeof(objAnswer) !== 'undefined') &&
                (objAnswer !== null)
                )
            {
                arrDisplaySentence[SentenceIndex].SelectedPos = objAnswer.PIAnswerPos
            } // end of if (objAnswer !== null)

            // 判斷 題目都做完了，就離開
            if (SentenceIndex >= intSCount - 1)
            {
                blnFinished = true
            }
            
            return blnFinished
        })

        console.log(COMP_NAME + ".FormatPIQuestionData arrDisplaySentence: ", arrDisplaySentence)

        return arrDisplaySentence
    } // end of FormatPIQuestionData
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 聲音播放按鈕 Cls
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetAudioPlayCls(StatePlayAudioIndex, QuestionIndex) 
    {
        let objCls = cssAssignmentPinyinIdentification.btnAudioPlay

        if (StatePlayAudioIndex === QuestionIndex)
        {
            objCls = cssAssignmentPinyinIdentification.btnAudioPlayDisabled
        }

        return objCls
    } // end of GetAudioPlayCls

    /*===========================================
    summary: 取得 答案選項欄位 Cls
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetAnswerCellCls(AnswerPos, SelectedPos, UnitPos) 
    {
        let objCls = cssAssignmentPinyinIdentification.divAnswer01Cell

        if (UnitPos === 1)
        {
            objCls = cssAssignmentPinyinIdentification.divAnswer01Cell

            if (UnitPos === SelectedPos)
            {
                if (UnitPos === AnswerPos)
                {
                    objCls = cssAssignmentPinyinIdentification.divAnswer01CellSuccess
                }
                else
                {
                    objCls = cssAssignmentPinyinIdentification.divAnswer01CellWrong
                }
            }
        }
        else if (UnitPos === 2)
        {
            objCls = cssAssignmentPinyinIdentification.divAnswer02Cell
            if (UnitPos === SelectedPos)
            {
                if (UnitPos === AnswerPos)
                {
                    objCls = cssAssignmentPinyinIdentification.divAnswer02CellSuccess
                }
                else
                {
                    objCls = cssAssignmentPinyinIdentification.divAnswer02CellWrong
                }
            }
        }

        return objCls
    } // end of GetAnswerCellCls

    /*===========================================
    summary: 取得 答案選項文字 Cls
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetAnswerTextCls(SelectedPos, UnitPos) 
    {
        let objCls = cssAssignmentPinyinIdentification.divAnswerText

        if (UnitPos === SelectedPos)
        {
            objCls = cssAssignmentPinyinIdentification.divAnswerTextSelected
        }

        return objCls
    } // end of GetAnswerTextCls

    /*===========================================
    summary: 取得 答案選項Icon Cls
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function GetAnswerIconCls(AnswerPos, SelectedPos, UnitPos) 
    {
        let objCls = null

        if (UnitPos === SelectedPos)
        {
            if (UnitPos === AnswerPos)
            {
                objCls = cssAssignmentPinyinIdentification.divAnswerIconSuccess
            }
            else
            {
                objCls = cssAssignmentPinyinIdentification.divAnswerIconWrong
            }
        }

        return objCls
    } // end of GetAnswerIconCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: Answer Cell 顯示Component  
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function ComponentAnswerCell( {QuestionData, UnitPos} )
    {   
        let strText = QuestionData.Pinyin
        if (parseInt(QuestionData.AnswerPos) !== UnitPos)
        {
            strText = QuestionData.WrongPinyin
        }
        
        return(
            <div className={GetAnswerCellCls(parseInt(QuestionData.AnswerPos), parseInt(QuestionData.SelectedPos), UnitPos)}>
                <div className={GetAnswerTextCls(parseInt(QuestionData.SelectedPos), UnitPos)}>
                    {strText}
                </div>

                <div className={GetAnswerIconCls(parseInt(QuestionData.AnswerPos), parseInt(QuestionData.SelectedPos), UnitPos)}/>
            </div>
        )
    } // end of ComponentAnswerCell
    
    /*===========================================
    summary: AudioPlay Cell 顯示Component  
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function ComponentAudioPlayCell( {StatePlayAudioIndex, QuestionData, QuestionIndex} )
    {   
        return(
            <div className={GetAudioPlayCls(StatePlayAudioIndex, QuestionIndex)} onClick={() => AudioPlayOnTapHandler(QuestionData.AudioFN, QuestionIndex)}/>
        )
    } // end of ComponentAudioPlayCell

    /*===========================================
    summary: No Cell 顯示Component  
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function ComponentNoCell( {QuestionIndex} )
    {   
        let strNo = (QuestionIndex + 1).toString() + "."

        return(
            <div className={cssAssignmentPinyinIdentification.divNoCell}>
                {strNo}
            </div>
        )
    } // end of ComponentNoCell
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render QuestionUnit 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderQuestionUnitWrapper(QuestionData, QuestionIndex)
    {
        return (
            <>
                <ComponentNoCell QuestionIndex={QuestionIndex} />

                <ComponentAudioPlayCell StatePlayAudioIndex={playAudioIndex} QuestionData={QuestionData} QuestionIndex={QuestionIndex} />

                <ComponentAnswerCell QuestionData={QuestionData} UnitPos={1} />
                <ComponentAnswerCell QuestionData={QuestionData} UnitPos={2} />
            </>
        )
    } // end of RenderQuestionUnitWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignmentPinyinIdentification.divContent}>
                    {marrDisplayQuestion.map((QuestionData, QuestionIndex) =>
                        <div key={QuestionIndex} className={cssAssignmentPinyinIdentification.divQuestionMain}>
                            {RenderQuestionUnitWrapper(QuestionData, QuestionIndex)}
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/30 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssAssignmentPinyinIdentification.divMain}>
                {RenderContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignmentPinyinIdentification